import { render, staticRenderFns } from "./DeleteReservationModal.vue?vue&type=template&id=ebd46ea2"
import script from "./DeleteReservationModal.vue?vue&type=script&lang=js"
export * from "./DeleteReservationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports